import {Injectable} from '@angular/core';
import {Burly} from 'kb-burly';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {FAQResponse} from '../responses/faq.response';
import {FAQEntry} from '../models/faq-entry.model';

@Injectable({
  providedIn: 'root'
})
export class TorchFAQService {

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient) {
  }

  getFAQEntries(page: number = 0, limit: number = 50): Observable<FAQEntry[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/documentation/faq')
      .addQuery('limit', limit)
      .addQuery('page', page)
      .get;

    return this.httpClient.get<FAQResponse>(endpointURL).pipe(
      map(response => response.data)
    );
  }
}
